import React from "react";
import clsx from "clsx";

import styles from "./styles.module.css";

export type SvgIconProps = {
  className?: string;
};

const IconWrap: React.FC<React.PropsWithChildren<SvgIconProps>> = ({
  children,
  className,
}) => {
  return (
    <span className={clsx(styles.iconWrapContainer, className)}>
      {children}
    </span>
  );
};

export default IconWrap;
